var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { Tooltip } from 'devextreme-react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import styles from './function-name.module.scss';
export var FunctionName = /** @class */ (function (_super) {
    __extends(FunctionName, _super);
    function FunctionName() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isTooltipVisible = false;
        return _this;
    }
    FunctionName.prototype._showTooltip = function () {
        this._isTooltipVisible = true;
    };
    FunctionName.prototype._hideTooltip = function () {
        this._isTooltipVisible = false;
    };
    FunctionName.prototype.render = function () {
        var _a;
        var name = (_a = this.props, _a.name), id = _a.id, code = _a.code;
        return (React.createElement("span", { className: styles.name, onMouseEnter: this._showTooltip, onMouseLeave: this._hideTooltip, id: id },
            code,
            React.createElement(Tooltip, { visible: this._isTooltipVisible, target: "#".concat(id) }, name)));
    };
    __decorate([
        observable
    ], FunctionName.prototype, "_isTooltipVisible", void 0);
    __decorate([
        action.bound
    ], FunctionName.prototype, "_showTooltip", null);
    __decorate([
        action.bound
    ], FunctionName.prototype, "_hideTooltip", null);
    FunctionName = __decorate([
        observer
    ], FunctionName);
    return FunctionName;
}(React.PureComponent));
